// Colours for the property Market Update flow (Monday 13377764940).
// MU_RED is the red Christian pointed at on Ignite's "Create report" button; it
// is kept for the one primary action per screen. SKY is the Collings sky blue
// (collings-aquamarine); Christian, 28 Oct 2026: "Make the dark blue our sky
// blue colour".
export const MU_RED = "#e4002b";
export const SKY = "#55c5d0";
export const TEAL = SKY;

export const redButtonClass =
  "inline-flex items-center justify-center gap-1.5 rounded-lg text-white text-sm font-semibold transition hover:brightness-95 disabled:opacity-40 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#e4002b]";

export const outlineButtonClass =
  "inline-flex items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white text-sm font-semibold text-gray-800 transition hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-[#55c5d0]/30";

export const inputClass =
  "w-full px-3 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none focus:border-[#55c5d0] focus:ring-2 focus:ring-[#55c5d0]/15";

const INT = new Intl.NumberFormat("en-AU", { maximumFractionDigits: 0 });
export const fmtInt = (v) => INT.format(Number(v) || 0);

// 0 is "no price recorded", never a $0 sale.
export const money = (v) => (!Number(v) ? "" : `$${INT.format(Math.round(Number(v)))}`);

// A calendar date (sold / listed day), so read in UTC: no timezone can move it.
const MONTH_YEAR = new Intl.DateTimeFormat("en-AU", { month: "short", year: "numeric", timeZone: "UTC" });
export const monthYear = (iso) => {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? "" : MONTH_YEAR.format(d);
};

export const vendorName = (v) => [v?.first_name, v?.last_name].filter(Boolean).join(" ");
